import { Component, OnInit, Output, OnDestroy, OnChanges } from "@angular/core";
import { AuthenticationService } from "../../../core/services/authentication.service";
import { Router, ActivatedRoute, Params, NavigationEnd } from "@angular/router";
import { MessagesService } from "../../../entities/messages/messages.service";
import { MessageType } from "../../../shared/constants";
import { SessionStateService } from "../../../core/services/session-state.service";
import { GeneralService } from "../../../shared/services/general.service";
import { Subscription } from "rxjs/Subscription";
import { Observable } from "rxjs/Observable";
import { IotService } from "../../../core/services/iot.service";
import { environment } from "../../../../environments/environment";
import { ProfileService } from "../../../entities/profile/profile.service";
import { UserDetail } from "../../../entities/profile/profile.model";

const DEFAULT_LANGUAGE_FOR_FLAG = "PT";

@Component({
  selector: "app-topbar-layout",
  templateUrl: "./topbar-layout.component.html",
  styleUrls: ["./topbar-layout.component.scss"],
})
export class TopbarLayoutComponent implements OnInit, OnDestroy {
  coackMarksState = false;
  queryParamsSubscription: Subscription;
  loading = true;
  unreadMsgNr: string;
  flagUrl: string;
  isMessageIconHover: boolean;
  isProfileIconHover: boolean;
  isHelpIconHover: boolean;
  isMobile;
  isWindowsPhone = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthenticationService,
    private messageService: MessagesService,
    private sessionStateService: SessionStateService,
    private generalService: GeneralService,
    private iotService: IotService,
    private profileService: ProfileService
  ) {}

  ngOnInit() {
    this.loadCoachMarkState();
    this.isMobile = this.generalService.isMobile();
    this.isWindowsPhone = this.generalService.isWindowsPhone();

    this.verifyLang()
      .finally(() => {
        this.loading = false;
        this.getUnreadMessages();
      })
      .catch((err) => {
        this.selectedLangUK();
        return Observable.empty();
      })
      .subscribe((user: UserDetail) => {
        this.verifyLang(user.languageCode);
      });
  }

  getUnreadMessages(): void {
    this.messageService.getUnreadMessages().subscribe((_return) => {
      if (_return) {
        this.unreadMsgNr = _return.toString();
      }
    });
  }

  highlightMessages(): boolean {
    return this.isInMessages() || this.isMessageIconHover;
  }

  highlightProfile(): boolean {
    return this.isInProfile() || this.isProfileIconHover;
  }

  highlightHelp(): boolean {
    return this.isInHelp() || this.isHelpIconHover;
  }

  isInMessages(): boolean {
    return this.router.url === "/messages";
  }

  isInProfile(): boolean {
    return this.router.url === "/profile";
  }

  isInHelp(): boolean {
    return (
      this.router.url === "/faq" ||
      this.router.url === "/tutorials" ||
      this.router.url === "/contacts" ||
      this.router.url === "/termsandprivacy"
    );
  }

  isInFAQ(): boolean {
    return this.router.url === "/faq";
  }

  onLogout() {
    //this.iotService.disconnect();
    this.authService.logout();
  }

  onProfile() {
    this.router.navigate(["/profile"]);
  }

  onMessages() {
    this.router.navigate(["/messages"]);
  }

  getLanguage() {
    return this.sessionStateService.getLang() || DEFAULT_LANGUAGE_FOR_FLAG;
  }

  selectedLangPT() {
    this.getQueryParams();
    this.generalService.usePortuguese();
    this.sessionStateService.setLang("PT");
    this.flagUrl = "../assets/img/flags/portugal.svg";
  }

  selectedLangUK() {
    this.getQueryParams();
    this.generalService.useEnglish();
    this.sessionStateService.setLang("EN");
    this.flagUrl = "../assets/img/flags/united-kingdom.svg";
  }

  selectedLangES() {
    this.getQueryParams();
    this.generalService.useSpanish();
    this.sessionStateService.setLang("ES");
    this.flagUrl = "../assets/img/flags/spain.svg";
  }

  verifyLang(language?: string): Observable<any> {
    // First login not language was still defined, so getUser is called.
    const userLanguage = language
      ? language
      : this.sessionStateService.getLang();

    switch (userLanguage) {
      case "EN": {
        this.selectedLangUK();
        break;
      }
      case "PT": {
        this.selectedLangPT();
        break;
      }
      case "ES": {
        this.selectedLangES();
        break;
      }
      default: {
        return this.profileService.getUser();
      }
    }
    return Observable.empty();
  }

  changeLang(lang: string) {
    switch (lang) {
      case "EN": {
        this.selectedLangUK();
        break;
      }
      case "PT": {
        this.selectedLangPT();
        break;
      }
      case "ES": {
        this.selectedLangES();
        break;
      }
      default: {
        this.selectedLangUK();
      }
    }
    if (this.router.url === "/tutorials" || this.router.url === "/faq") {
      window.location.reload();
    }
  }

  getQueryParams() {
    this.queryParamsSubscription = this.activatedRoute.queryParams.subscribe(
      (params: Params) => {
        const queryParams: Params = Object.assign({}, "");
        if (params["homeType"] !== undefined) {
          queryParams["homeType"] = params["homeType"];
          this.router.navigate([], { queryParams: queryParams });
          // } else if (params['energyType'] !== undefined && params['houseId'] === undefined) {
          //   queryParams['energyType'] = params['energyType'];
          //   //queryParams['reportId'] = params['reportId'] ? params['reportId'] : undefined;
          //   //queryParams['houseId'] = params['houseId'] ? params['houseId'] : undefined;
          //   this.router.navigate([], { queryParams: queryParams });
        } else if (params["deviceType"] !== undefined) {
          queryParams["deviceType"] = params["deviceType"];
          this.router.navigate([], { queryParams: queryParams });
        } else if (params["scheduleType"] !== undefined) {
          queryParams["scheduleType"] = params["scheduleType"];
          this.router.navigate([], { queryParams: queryParams });
        } else if (params["tutorialType"] !== undefined) {
          queryParams["tutorialType"] = params["tutorialType"];
          this.router.navigate([], { queryParams: queryParams });
        } else if (params["profileEditType"] !== undefined) {
          queryParams["profileEditType"] = params["profileEditType"];
          this.router.navigate([], { queryParams: queryParams });
        } else if (params["profileType"] !== undefined) {
          queryParams["profileType"] = params["profileType"];
          this.router.navigate([], { queryParams: queryParams });
        } else if (params["efficiencyType"] !== undefined) {
          queryParams["efficiencyType"] = params["efficiencyType"];
          this.router.navigate([], { queryParams: queryParams });
        }
      }
    );
  }
  ngOnDestroy(): void {
    this.queryParamsSubscription.unsubscribe();
  }

  openFaqPage() {
    this.router.navigate(["/faq"]);
  }

  openContacts() {
    this.router.navigate(["contacts"]);
  }

  openTutorials() {
    this.router.navigate(["tutorials"]);
  }

  openPrivacy() {
    if (this.sessionStateService.getLang() === "EN") {
      window.open(
        "https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/Privacy+Policy/Apps/Privacy+Policy_EN.pdf"
      );
    } else if (this.sessionStateService.getLang() === "PT") {
      window.open(
        "https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/Privacy+Policy/Apps/Privacy+Policy_PT.pdf"
      );
    } else if (this.sessionStateService.getLang() === "ES") {
      window.open(
        "https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/Privacy+Policy/Apps/Privacy+Policy_ES.pdf"
      );
    } else {
      // Default
      window.open(
        "https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/Privacy+Policy/Apps/Privacy+Policy_EN.pdf"
      );
    }
  }

  openOnboarding() {
    this.router.navigate(["onboarding"]);
  }

  loadCoachMarkState() {
    this.coackMarksState = this.sessionStateService.getCoachMarkState();
  }

  activateCoachMarks(event) {
    event.stopPropagation();
    this.coackMarksState = !this.coackMarksState;
    this.sessionStateService.setCoachMarkState(this.coackMarksState);
    this.sessionStateService.initializeCoachMarkIndividualState(
      this.coackMarksState ? true : false
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/gui-layout/topbar-layout/topbar-layout.component.ts